import React from "react";
import "./../App.css";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nome: "",
      cargo: window.location.search
        ? window.location.search.replace("?", "").replace(/%20/g, " ")
        : "",
      telefone: "(11) 2634-1788",
      celular: "",
      assinatura: false,
      erro: false,
      isInfluenciadorFelicidade: false,
    };
    this.state.cargo = decodeURI(this.state.cargo);
    this.signatureRef = React.createRef();
  }

  gerar() {
    if (this.state.nome && this.state.cargo) {
      this.setState({ assinatura: true, erro: false });
    } else {
      this.setState({ erro: true });
    }
  }

  copyTable() {
    const elTable = document.getElementById("table");
    elTable.style.setProperty(
      "background-image",
      'url("./img/img-fundo-branco.png")',
      "important"
    );
    elTable.style.setProperty("background-repeat", "no-repeat", "important");
    elTable.style.setProperty("background-size", "cover", "important");

    const cells = elTable.querySelectorAll("td, th");
    cells.forEach((cell) => {
      cell.style.removeProperty("background-color");
    });

    const link = document.getElementById("link");
    if (link) {
      link.style.setProperty("text-decoration", "none", "important");
      link.style.setProperty("text-decoration-line", "none", "important");
    }

    const fone = document.getElementById("fone");
    if (fone) {
      fone.style.setProperty("text-decoration", "none", "important");
      fone.style.setProperty("text-decoration-line", "none", "important");
      fone.style.setProperty("color", "#FFFFFF", "important");
    }

    let range, sel;

    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(elTable);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(elTable);
        sel.addRange(range);
      }
      document.execCommand("copy");
    }
    sel.removeAllRanges();

    this.setState({ copyToast: true });
    setTimeout(() => {
      this.setState({ copyToast: false });
    }, 2000);
  }

  getAssinatura() {
    const { nome, cargo, telefone, celular } = this.state;

    return (
      <table
        ref={this.signatureRef}
        id="table"
        cellPadding="0"
        cellSpacing="0"
        bgcolor="#FFFFFF"
        style={{
          borderCollapse: "collapse",
          width: "100%",
          fontFamily: "Arial, sans-serif",
          color: "#6d6d6d",
        }}
      >
        <tbody>
          <tr>
            {/* Coluna: Nome, cargo, telefone e redes sociais */}
            <td style={{ verticalAlign: "bottom", display: "block", paddingBottom: "13px" }}>
              <table cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <div
                      style={{
                        textAlign: "left",
                        width: "290px", 
                        height: "24px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span
                        style={{
                          fontSize:
                            nome.length > 30
                              ? "12px"
                              : nome.length > 19
                              ? "16px"
                              : "18px",
                          fontWeight: "bold",
                          fontFamily: "Arial, sans-serif",
                          display: "inline-block",
                        }}
                      >
                        {nome.toUpperCase()}
                      </span>
                    </div>
                  </tr>
                  <tr>
                    <td
                      style={{
                        paddingTop: "2px",
                        paddingBottom: "10px",
                      }}
                    >
                      <div>
                        <table cellPadding="0" cellSpacing="0">
                          <tbody>
                            <tr>
                              <td></td>
                              <td
                                style={{
                                  fontSize:
                                    cargo.length > 30
                                      ? "14px"
                                      : cargo.length > 24
                                      ? "14px"
                                      : "16px",
                                  fontFamily: "Arial, sans-serif",
                                }}
                              >
                                {cargo}
                              </td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        textAlign: "left",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: "14px",
                            fontFamily: "Arial, sans-serif",
                          }}
                        >
                          {telefone}
                          {celular ? " | " + celular : ""}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        paddingTop: "6px",
                        paddingBottom: "2px",
                        textAlign: "left",
                      }}
                    >
                      <a
                        href="https://www.facebook.com/TakaoMotor"
                        style={{
                          display: "inline-block",
                          marginRight: "10px",
                        }}
                      >
                        <img
                          src="./img/img-logo-facebook-menor.png"
                          alt="Facebook"
                          style={{ height: "32px" }}
                        />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/takao-motor/mycompany/"
                        style={{
                          display: "inline-block",
                          marginRight: "10px",
                        }}
                      >
                        <img
                          src="./img/img-logo-linkedin-menor.png"
                          alt="LinkedIn"
                          style={{ height: "32px" }}
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/takaomotor/"
                        style={{
                          display: "inline-block",
                          marginRight: "10px",
                        }}
                      >
                        <img
                          src="./img/img-logo-instagram-menor.png"
                          alt="TikTok"
                          style={{ height: "32px" }}
                        />
                      </a>
                      <a
                        href="https://www.tiktok.com/@takaomotor"
                        style={{
                          display: "inline-block",
                          marginRight: "10px",
                        }}
                      >
                        <img
                          src="./img/img-logo-tik-tok-menor.png"
                          alt="TikTok"
                          style={{ height: "32px" }}
                        />
                      </a>
                      <a
                        href="https://www.youtube.com/c/AcademiadoMotor"
                        style={{ display: "inline-block" }}
                      >
                        <img
                          src="./img/img-logo-youtube-menor.png"
                          alt="Youtube"
                          style={{ height: "32px" }}
                        />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            {/* Coluna: Logos goop + GPTW */}
            <td
              style={{
                verticalAlign: "right",
                textAlign: "center",
              }}
            >
              <table cellPadding="0" cellSpacing="0" align="center">
                <tbody>
                  <tr>
                    <td>
                      <img
                        src="./img/img-logo-goop-azul-menor.png"
                        alt="Goop"
                        style={{ height: "70px", display: "inline-block" }}
                      />
                    </td>
                    <td style={{ width: "22px" }}></td>
                    <td>
                      <img
                        src="./img/img-logo-gptw2026-menor.png"
                        alt="GPTW"
                        style={{ height: "100px", display: "inline-block" }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            {/* Coluna: Logo Takao */}
            <td
              rowSpan="1"
              style={{ verticalAlign: "bottom", paddingLeft: "10px" }}
            >
              <img
                src="./img/img-logo-takao-menor.png"
                alt="Takao"
                style={{ height: "155px", display: "block" }}
              />
            </td>
          </tr>

          {/* Linha base vermelha
          <tr>
            <td
              colSpan="3"
              style={{
                padding: 0,
                margin: 0,
                backgroundColor: "transparent",
                height: "1px",
              }}
            >
              <table
                width="93.7%"
                cellPadding="0"
                cellSpacing="0"
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        borderTop: "5px solid #EC1F28",
                      }}
                    >
                      &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr> */}
        </tbody>
      </table>
    );
  }

  copiarAssinatura = () => {
    const el = this.signatureRef.current;
    if (!el) {
      this.setState({
        erro: true,
        errorMessage: "Assinatura não encontrada para copiar.",
      });
      return;
    }

    const html = el.innerHTML;
    navigator.clipboard
      .writeText(html)
      .then(() => {
        alert("Assinatura copiada para a área de transferência!");
      })
      .catch(() => {
        this.setState({
          erro: true,
          errorMessage: "Erro ao copiar a assinatura.",
        });
      });
  };

  formatarCelular(value) {
    let v = value.replace(/\D/g, "");
    if (v.length > 11) v = v.slice(0, 11);
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
    v = v.replace(/(\d{5})(\d)/, "$1-$2");
    return v;
  }

  render() {
    return (
      <div>
        <h3>Gerador de assinaturas</h3>
        <div className="body">
          <div className="campo">
            <div className="label">Nome*</div>
            <input
              maxLength={25}
              onChange={(e) => this.setState({ nome: e.target.value })}
              type="text"
            />
          </div>
          <div className="campo">
            <div className="label">Área*</div>
            <input
              maxLength={40}
              value={this.state.cargo}
              onChange={(e) => this.setState({ cargo: e.target.value })}
              type="text"
            />
          </div>
          <div className="campo">
            <div className="label">Telefone*</div>
            <input
              value={this.state.telefone}
              onChange={(e) =>
                this.setState({
                  telefone: this.formatarCelular(e.target.value),
                })
              }
              type="text"
            />
          </div>
          <div className="campo">
            <div className="label">Celular</div>
            <input
              placeholder="(00) 00000-0000"
              type="text"
              maxLength={15}
              onChange={(e) =>
                this.setState({ celular: this.formatarCelular(e.target.value) })
              }
              value={this.state.celular}
            />
          </div>

          <button
            style={{ cursor: "pointer", marginBottom: "30px" }}
            onClick={() => this.gerar()}
          >
            Gerar Assinatura
          </button>

          {this.state.erro && (
            <span style={{ color: "red" }}>Preencha todos os campos!</span>
          )}

          {this.state.assinatura && this.state.nome && this.state.cargo && (
            <div>
              {this.getAssinatura()}
              <button
                style={{ margin: "50px 0" }}
                onClick={() => this.copyTable()}
              >
                Copiar Assinatura
              </button>
              {this.state.copyToast && (
                <div
                  id="toast"
                  style={{
                    position: "relative",
                    bottom: "130px",
                    maxWidth: "150px",
                    borderRadius: "5px",
                    margin: "0 auto",
                    color: "#fff",
                    backgroundColor: "#52DA26",
                    padding: "8px",
                  }}
                >
                  Assinatura copiada!
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Home;
